import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wellcome',
  templateUrl: './wellcome.component.html',
  styleUrls: ['./wellcome.component.css']
})
export class WELLCOMEComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
